module.exports = __webpack_public_path__ + "static/img/home-co2.b9675421.png";